import { frontendURL } from 'dashboard/helper/URLHelper';
import { ROLES, CONVERSATION_PERMISSIONS } from 'dashboard/constants/permissions.js';
import KanbanBoard from './pages/KanbanBoard.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_index',
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
    component: KanbanBoard,
  },
];
